import React from "react";
import hero5 from "../assets/images/hero-5.png";
import { Typewriter } from "react-simple-typewriter";
import bg from "../assets/images/Black-Animation-Background.svg";

const Hero = () => {
  return (
    <section
      style={{
        backgroundImage: `url(${bg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
      className="flex justify-center"
    >
      <section
        id="home"
        className="min-h-screen flex py-10 md:flex-row flex-col items-center md:mt-8 mt-12"
      >
        <div className="flex-1 flex items-center justify-center h-full md:mb-0 mb-7 md:ml-56">
          <img src={hero5} alt="" className="md:w-8/12 h-8/12 object-cover" />
        </div>
        <div className="flex-1 ">
          <div className="md:text-left text-center">
            <h1 className="md:text-5xl text-2xl md:leading-normal leading-10 text-white font-bold">
              <span className="text-indigo-600 md:text-6xl text-5xl">
                Hello!
                <br />
              </span>
              I'm <span>Nahid Parvez</span>
            </h1>
            <h4 className="md:text-2xl text-lg md:leading-normal leading-5 mt-4 font-bold text-gray-600">
              <span style={{ color: "#5C6BC0" }}>
                {/* Style will be inherited from the parent element */}
                <Typewriter
                  words={[
                    "Fullstack Developer",
                    "MERN Stack Developer",
                    "Web Developer",
                    "React Developer",
                    "Frontend Developer",
                    "Backend Developer",
                  ]}
                  loop={false}
                  cursor
                  cursorStyle="_"
                  typeSpeed={70}
                  deleteSpeed={50}
                  delaySpeed={1000}
                />
              </span>
            </h4>
            <a
              href="https://drive.google.com/file/d/193egZDDtkpX2yqX3VFm0rrhcUPQApBTr/view?usp=sharing"
              target="_blank"
            >
              <button className="px-10 py-3 rounded-md border-2 border-indigo-700 transition duration-500 hover:bg-indigo-600 mt-8 font-semibold text-lg">
                My Resume
              </button>
            </a>
          </div>
        </div>
      </section>
    </section>
  );
};

export default Hero;
